"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.updateAll = exports.kill = exports.removeFocus = exports.setFocus = exports.handleKeyboardInput = exports.hasFocus = exports.setVisible = exports.create = exports.defaultFrames = exports.textInputAlphabet = void 0;
var phaserUtil_sidecar_1 = require("../engine/phaserUtil-sidecar");
var entitiesUtils_sidecar_1 = require("../entities/entitiesUtils-sidecar");
var imports_1 = require("../lib/imports");
var common_sidecar_1 = require("../main/common-sidecar");
var frameInfo_sidecar_1 = require("../main/frameInfo-sidecar");
var spriteMap_sidecar_1 = require("../main/spriteMap-sidecar");
exports.textInputAlphabet = 'abcdefghijklmnopqrstuvwxyz1234567890-+*=/.,;:\'"?!()';
var objs = [];
var focusedTextInput = null;
var w = 50;
var h = 10;
var oy = h * 3 + 2 * 3;
exports.defaultFrames = [
    frameInfo_sidecar_1.frameInfo.fiRaw(4, 2, oy + 2, w, h),
    frameInfo_sidecar_1.frameInfo.fiRaw(4, 2, oy + 2 + h + 2, w, h),
    frameInfo_sidecar_1.frameInfo.fiRaw(4, 2, oy + 2 + 2 + 2 + h + h, w, h),
    // disabled: frameInfo.fi32(1, 5, 10),
    // bought: frameInfo.fi32(1, 5, 11),
];
function create(layer, x, y, text, onChange) {
    var imageBackground = spriteMap_sidecar_1.spriteMap.createImageFromRawFrameInfo(layer, exports.defaultFrames[0], x, y, 4);
    // let _text = stevieTexts.create(scene.getContext().font16, x + 10 + 4, y + 10)
    // stevieTexts.setText(_text, text)
    var obj = {
        eType: 'text-input',
        id: common_sidecar_1.common.createId(),
        idLoaded: 0,
        imageBackground: imageBackground,
        isFocused: false,
        // text: _text,
        onChange: onChange,
        selectionStart: 0,
        isDead: false,
    };
    objs.push(obj);
    phaserUtil_sidecar_1.phaserUtil.setInteractive(imageBackground);
    // imageBackground.on('pointerover', () => {
    //   obj.isOver = true
    // })
    // imageBackground.on('pointerout', () => {
    //   obj.isOver = false
    //   obj.isMouseDown = false
    // })
    imageBackground.on('pointerdown', function () {
        // obj.isFocused = true
        setFocus(obj);
        // let scene = common.getScene()
        // if (scene.game.input.activePointer.rightButtonDown()) {
        //   obj.isMouseRightDown = true
        // } else {
        //   obj.isMouseDown = true
        // }
    });
    imageBackground.on('pointerup', function () {
        // if (obj.isMouseDown) {
        //   obj.isMouseDown = false
        //   if (obj.imageBackground.visible) {
        //     obj.onClick()
        //   }
        // }
        // if (obj.isMouseRightDown) {
        //   obj.isMouseRightDown = false
        // }
    });
    return obj;
}
exports.create = create;
function setVisible(obj, visible) {
    obj.imageBackground.visible = visible;
    // stevieTexts.setVisible(obj.text, visible)
    if (!visible) {
        removeFocus(obj);
    }
}
exports.setVisible = setVisible;
function hasFocus() {
    return focusedTextInput !== null;
}
exports.hasFocus = hasFocus;
function handleKeyboardInput(key, keyCode, code) {
    console.log('key input', key, keyCode, code);
    var obj = focusedTextInput;
    if (obj) {
        var newText = ''; //obj.text.text
        if (exports.textInputAlphabet.includes(key.toLowerCase())) {
            newText += key;
        }
        var del = function () {
            //if (obj && obj.text.text.length > 0) {
            //newText = newText.substring(0, obj.text.text.length - 1)
            //}
        };
        if (code === 'Space') {
            newText += ' ';
        }
        if (code === 'Backspace') {
            del();
        }
        if (code === 'Delete') {
            del();
        }
        // if (newText !== obj.text.text) {
        //   console.log('text change!')
        //   stevieTexts.setText(obj.text, newText)
        //   obj.onChange(newText)
        // }
    }
}
exports.handleKeyboardInput = handleKeyboardInput;
function setFocus(obj) {
    imports_1.l.forEach(objs, function (c) {
        c.isFocused = false;
    });
    obj.isFocused = true;
    focusedTextInput = obj;
}
exports.setFocus = setFocus;
function removeFocus(obj) {
    if (focusedTextInput === obj) {
        focusedTextInput = null;
        obj.isFocused = false;
    }
}
exports.removeFocus = removeFocus;
function kill(obj) {
    obj.isDead = true;
    removeFocus(obj);
}
exports.kill = kill;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.imageBackground.destroy();
        //stevieTexts.kill(c.text)
    });
}
exports.updateAll = updateAll;
function update(obj) {
    if (obj.isFocused) {
        spriteMap_sidecar_1.spriteMap.setRawFrame(obj.imageBackground, exports.defaultFrames[2], 0, 0);
    }
    else {
        spriteMap_sidecar_1.spriteMap.setRawFrame(obj.imageBackground, exports.defaultFrames[0], 0, 0);
    }
}
exports.update = update;
